'use strict';

function ThanksController($filter, $anchorScroll, gettextCatalog) {
  this.$onInit = () => {
    this.data = this.parent.data;
    this.contribution = this.parent.contribution;

    $anchorScroll();
  };

  this.share = {
    twitter: () => {
      let url = new Uri('https://twitter.com/intent/tweet');

      url.addQueryParam(
        'text',
        gettextCatalog.getString(
          'I just contributed to {{project}}, by {{church}}.',
          {
            project: this.data.campaign.title,
            church: this.data.organization.name,
          }
        )
      );

      url.addQueryParam(
        'url',
        location.origin + '/' + this.data.campaign.alias
      );
      url.addQueryParam('via', 'churchdesk');

      return url.toString();
    },
  };

  this.generateMessage = function () {
    function escape(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    var message = this.data.campaign.webBody
      .replace(
        new RegExp(escape('[name:first]'), 'g'),
        this.contribution.firstName
      )
      .replace(
        new RegExp(escape('[name:last]'), 'g'),
        this.contribution.lastName
      )
      .replace(
        new RegExp(escape('[project:name]'), 'g'),
        this.data.campaign.title
      )
      .replace(
        new RegExp(escape('[amount]'), 'g'),
        $filter('currency')(
          this.contribution.amount,
          this.data.organization.currency
        )
      )
      .replace(
        new RegExp(escape('[church:name]'), 'g'),
        this.data.organization.name
      );

    return $filter('linky')(message);
  };
}

angular
  .module('cdPay.components.projectThanks', [])
  .component('cdProjectThanks', {
    templateUrl: 'components/project-thanks/project-thanks.html',
    controller: ThanksController,
    require: {
      parent: '^cdProjectCheckout',
    },
  });
